import { ofType } from "redux-observable";
import { of } from "rxjs";
import { guard } from "../../guards/guard";
import { actionDoghouseGiveTreat, actionDoghouseNotEnoughTreat, TypeActionDoghouse, } from "../actionDoghouse";
import { checkDoghouseTreatAvailability } from "../check/checkDoghouseTreatAvailability";
export var epicDoghouseGiveRequest = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionDoghouse.Request), guard(state$, deps, function (action) {
        return of(actionDoghouseGiveTreat(action.isRepeat));
    })([checkDoghouseTreatAvailability(function () { return of(actionDoghouseNotEnoughTreat()); })]));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/doghouse/epics/epicDoghouseGiveRequest.ts
// module id = 1836
// module chunks = 3